
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';
import Vue from 'vue';
import "bootstrap";

window.angular = require('angular');
window.dayjs = require('dayjs');
window.axios = require('axios');
window.Vue = require('vue');

window.Vue = Vue;

Vue.config.productionTip = false;

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);

const env = process.env.MIX_APP_ENV;



try {
    window.$ = window.jQuery = require('jQuery');
    require('bootstrap');

} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });









// IE11 Promise polyfill
if (!window.Promise) {
    window.Promise = require('es6-promise').Promise;
}

// IE11 Object Assign polyfill
if (typeof Object.assign !== 'function') {
    Object.defineProperty(Object, 'assign', {
        value: function assign(target, varArgs) {
            if (target === null || target === undefined) {
                throw new TypeError('Cannot convert undefined or null to object');
            }

            const to = Object(target);

            for (let index = 1; index < arguments.length; index++) {
                const nextSource = arguments[index];

                if (nextSource !== null && nextSource !== undefined) {
                    for (const nextKey in nextSource) {
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
            return to;
        },
        writable: true,
        configurable: true,
    });
}


/**
 * Next we will register the CSRF Token as a common header so that
 * all outgoing HTTP requests automatically have it attached.
 */
 window._token = document.head.querySelector('meta[name="csrf-token"]').content;
 window.app = angular.module('cashcalc', env === 'production' ? ['ngSentry'] : []);
 
 window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
 window.axios.defaults.headers.common['X-CSRF-TOKEN'] = window._token;
 
 app.run([
     '$http',
     $http => {
         $http.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
         $http.defaults.headers.common['X-CSRF-TOKEN'] = window._token;
     },
 ]);
 
 /**
  * Convert the first charatcer of a string to uppercase.
  */
 window.ucfirst = string => {
     return string.charAt(0).toUpperCase() + string.slice(1);
 };
 
 /**
  * Determine if a property or variable is empty.
  */
 window.empty = item => {
     return typeof item === 'undefined' || item === null || item.length === 0;
 };
 
 /**
  * Get the browser, browser version and platform of the current user.
  */
 window.getBrowser = () => {
     const ua = navigator.userAgent;
     let tem;
     let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
 
     if (/trident/i.test(M[1])) {
         tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
         return { name: 'IE', version: tem[1] || '' };
     }
 
     if (M[1] === 'Chrome') {
         tem = ua.match(/\bOPR|Edge\/(\d+)/);
         if (tem != null) {
             return { name: 'Opera', version: tem[1] };
         }
     }
 
     M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
     tem = ua.match(/version\/(\d+)/i);
     if (tem != null) {
         M.splice(1, 1, tem[1]);
     }
 
     return {
         name: M[0],
         version: M[1],
         platform: navigator.platform,
     };
 };
 
